import { useRef, useState } from 'react';
import { Checkbox, Modal, Stack } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { employeesService, type EmployeeView } from '../../../../services/employees/employees.service';

export const MobileDepartmentsModal = ({ opened, onClose, tenantId, employees }: {
  opened: boolean;
  onClose: () => void;
  tenantId: string;
  employees: EmployeeView[];
}) => {
  const [saving, setSaving] = useState(false);
  const inFlight = useRef(false);
  const mobileNames = employees.find((employee) => employee.mobileDepartmentNames)?.mobileDepartmentNames ?? [];
  const names = [...new Set([...mobileNames, ...employees.flatMap((employee) => employee.departments?.map((department) => department.name) ?? ['כללי'])])].sort((first, second) => first.localeCompare(second, 'he'));

  const save = async (name: string, mobile: boolean) => {
    if (inFlight.current || mobileNames.includes(name) === mobile) return;
    inFlight.current = true;
    setSaving(true);
    try {
      await employeesService.updateDepartment(tenantId, name, { mobile });
    } catch {
      notifications.show({ color: 'red', message: 'עדכון המחלקה נכשל' });
    } finally {
      inFlight.current = false;
      setSaving(false);
    }
  };

  return <Modal opened={opened} onClose={onClose} title="ניהול מחלקות" centered
    closeOnClickOutside={!saving} closeOnEscape={!saving} closeButtonProps={{ disabled: saving }}>
    <Stack gap="md">
      {names.map((name) => <Checkbox key={name} label={`${name} · מובייל`} aria-label={`${name} מובייל`}
        checked={mobileNames.includes(name)} disabled={saving}
        onChange={(event) => { const mobile = event.currentTarget.checked; void save(name, mobile); }} />)}
    </Stack>
  </Modal>;
};